/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CouponDto { 
    id: string;
    programId: string;
    name: string;
    slug: string;
    status: CouponDto.StatusEnum;
    description?: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}
export namespace CouponDto {
    export const StatusEnum = {
        Available: 'available',
        NotAvailable: 'not_available',
        Deleted: 'deleted'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


